import React from 'react'
import styled from 'styled-components'
import { useIntl } from 'react-intl'
import { rem } from 'polished'

import { LinkOut } from '../../../icons'
import { authenticationMessages } from '../../../translations'
import { baseTiltifyUrl, getSubdomainUrl } from '../../../utils/tiltifyUrl'
import { Button } from '../../Button'

const StyledLabel = styled.div`
  text-align: center;
  padding-bottom: ${rem(10)};
  color: ${({ theme }) => theme.textColor};
`

const StyledButton = styled(Button)(
  ({ theme }) => `
    width: 100%;
    font-weight: bold;
    background-color: ${theme.isDark ? 'transparent' : theme.grey};
    border-color: ${theme.isDark ? theme.darkTextColor : theme.grey};
    color: ${theme.darkTextColor};
    box-sizing: border-box;

    & > div > span {
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: center;
    }
`
)

const StyledIcon = styled.svg(
  ({ theme }) => `
    fill: ${theme.darkTextColor};
  `
)

export const CauseSection = () => {
  const { formatMessage } = useIntl()

  return (
    <>
      <StyledLabel>{formatMessage(authenticationMessages.causeLogin)}</StyledLabel>
      <StyledButton
        forwardedAs='a'
        size='medium'
        target='__blank'
        rel='noopener noreferrer'
        href={`${getSubdomainUrl(baseTiltifyUrl(), 'app')}/causes/login`}
        iconRight={<StyledIcon as={LinkOut} height={20} width={20} />}
      >
        {formatMessage(authenticationMessages.causeSignIn)}
      </StyledButton>
    </>
  )
}
